import { style } from 'typestyle/lib';
import { primaryTextColor } from 'src/utils/Style/Theme';
import {
  TREND_UP_COLOR,
  TREND_DOWN_COLOR,
  NO_TREND_COLOR,
  MAP_BUBBLE_MIN_SIZE,
  MAP_BUBBLE_MAX_SIZE,
} from 'src/pages/Hindsighting/MacroTrends/GeoTrends/GeoTrends.styles';

// Global Region Volume and Trend styles.
export const geoMapStyles = {
  bubbleMaxSize: MAP_BUBBLE_MAX_SIZE,
  bubbleMinSize: MAP_BUBBLE_MIN_SIZE,
  noTrendColor: NO_TREND_COLOR,
  trendDownColor: TREND_DOWN_COLOR,
  trendUpColor: TREND_UP_COLOR,
};

export const summaryContainer = style({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  $nest: {
    '.summary-content-container': {
      $debugName: 'summary-content-container',
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      minHeight: 0,
    },
    // this should be an exact match to what `CategorySummary.styles.ts` contains, they are the same component
    '.choice-productivity-container': {
      display: 'flex',
      height: '100%',
      $nest: {
        '&.print': {
          height: 'auto',
        },
        '.fin-wrapper': {
          display: 'flex',
          width: '20%',
          alignItems: 'center',
          minWidth: 220,
          // override key financial item styles when rendered in choice productivity
          $nest: {
            '.key-financial-item': {
              backgroundColor: 'white',
            },
            header: {
              fontWeight: 300,
            },
            '.primary': {
              color: primaryTextColor,
              flex: 'none',
              marginRight: '1rem',
            },
          },
        },
        '.choice-wrapper': {
          flex: 1,
          display: 'flex',
          flexWrap: 'wrap',
          overflow: 'auto',
        },
      },
    },
    '.flex-accordion': {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 0,
      $nest: {
        // this sucks but I need to target the accordions styles
        // to dynamically fill the available space vertically in each nested container
        '.s5-MuiCollapse-entered': {
          flex: 1,
          display: 'flex',
        },
        '.s5-MuiCollapse-wrapper': {
          flex: 1,
          display: 'flex',
          minWidth: 0,
        },
        '.s5-MuiCollapse-wrapperInner': {
          flex: 1,
          display: 'flex',
          $nest: {
            '& > [role="region"]': {
              flex: 1,
              display: 'flex',
              minWidth: 0,
            },
            '& > [role="region"] > .s5-MuiAccordionDetails-root': {
              flex: 1,
              minWidth: 0,
            },
          },
        },
        // end suckiness
      },
    },
    '.macro-trend-analysis-items-container': {
      flex: 1,
      display: 'flex',
      minWidth: 0,
      $nest: {
        '& .chart-container': {
          height: '100%',
          minWidth: 0,
          margin: '0 5px',
        },
      },
    },
  },
});
